import React from 'react';
import { 
  Backdrop, 
  CircularProgress, 
  LinearProgress, 
  Box,
  Typography
} from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/types';

export const GlobalLoader: React.FC = () => {
  const { isLoading, backdrop } = useSelector((state: RootState) => state.loading);

  if (!isLoading) return null;

  if (backdrop) {
    return (
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          backdropFilter: 'blur(12px)',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" size={60} />
        <Typography variant="body2">Loading...</Typography>
      </Backdrop>
    );
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <LinearProgress />
    </Box>
  );
};